import React, { useEffect } from "react"
import { connect } from "react-redux"
import { getPaymentsHistory, getInvoiceHistory } from "../../../../middleware"
import Presentation from "./Presentation"
import MetaInfo from "../../../../../../shared/getMetaInfo"
import parser from 'html-react-parser'

function Container(props) {
  const { history, isEmpty, isLoaded, onClickHistory, totalAmount, _get_invoice_history, state } = props
  const metaObj = new MetaInfo()

  useEffect(() => { }, [props.id])

  const getInformationBasedOnDataChange = (info = { eventDetails: {}, type: "" }) => {
    if (info.type === "madePayment") {
      return `Received amount $${info.paymentAmount}`
    }
    const { before, after, subject = {} } = info.eventDetails
    if (info.type === "invoiceCreated") {
      const {
        employeeID = ""
      } = subject
      return "Invoice created"
    }
    else if (info.type === "invoiceToVoid") {
      return parser("Void remarks" + (after?.voidReason ? " - " + after.voidReason : ''))
    }
    else if (info.type === "sendInvoiceToClient") {
      return "Invoice sent to client"
    }
    else if (info.type === "reminderToClient") {
      return "Invoice reminder sent to client"
    }
    else if (info.type === "clientApproveInvoice") {
      return "Invoice was approved by client"
    }
    else if (info.type === "clientRejectInvoice") {
      return "Invoice was rejected by client"
    }
    else if (info.type === "invoiceUpdated") {
      return "Invoice is updated"
    }
    else if (info.type === "invoiceToVoidReasonUpdated") {
      return parser("Void remarks updated" + (after?.voidReason ? " - " + after.voidReason : ''))
    }

    else if (info.type === "invoiceFollowup"){
      if('actionDesc' in info){
        return <span>{parser(info.actionDesc)}</span>
      }else{
        return (
          <span>
            <span>Invoice follow up {info.subject.invoiceID}</span>{' '}
            <span>{parser(
              'Follow up' +
                (info?.eventDetails?.after?.followupComment
                  ? ' - ' + info?.eventDetails?.after.followupComment
                  : '')
            )}</span>
          </span>
        )
      }
    }
    else if (info.type === "invoiceFollowupUpdated"){
      if('actionDesc' in info){
        return <span>{parser(info.actionDesc)}</span>
      }else{
        return (
          <span>
            <span>Invoice follow up {info.subject.invoiceID}</span>{' '}
            <span>{parser(
              'Follow up updated' +
                (info?.eventDetails?.after?.followupComment
                  ? ' - ' + info?.eventDetails?.after.followupComment
                  : '')
            )}</span>
          </span>
        )
      }
    }else if (info.type === "newPaymentForInvoice" || info.type === "updatePaymentForInvoice") {
      return <span>{parser(info.actionDesc)}</span>
    }

    return ""
  }

  return (
    <div>
      <Presentation
        history={history}
        isLoaded={isLoaded}
        isEmpty={isEmpty}
        onClickHistory={onClickHistory}
        totalAmount={totalAmount}
        _get_invoice_history={_get_invoice_history}
        state={state}
        getInformationBasedOnDataChange={getInformationBasedOnDataChange}
      />
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    history: state.payments.history.payments_history,
    isLoaded: state.payments.history.isLoaded,
    isEmpty: state.payments.history.isEmpty,
    state: state.payments.history
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClickHistory: () => {
      dispatch(getPaymentsHistory(ownProps.id))
    },
    _get_invoice_history: () => dispatch(getInvoiceHistory(ownProps.id))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)
